// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  killId: __t.u64().primaryKey().name("kill_id"),
  victim: __t.identity(),
  victimName: __t.string().name("victim_name"),
  chassisKey: __t.string().name("chassis_key"),
  shipName: __t.string().name("ship_name"),
  systemKey: __t.string().name("system_key"),
  attackerKind: __t.string().name("attacker_kind"),
  attackerRef: __t.string().name("attacker_ref"),
  lostCompsJson: __t.string().name("lost_comps_json"),
  valueSov: __t.i64().name("value_sov"),
  at: __t.timestamp(),
});
